import React from 'react'
import ReactJson from '@microlink/react-json-view'
import { isString } from '../../../../util/StringUtil'
import { DmcText } from '../../../common/DmcText'

export function SimpleMessageSummary({ messageDetails }) {
  if (isString(messageDetails)) {
    return <DmcText text={messageDetails} />
  }
  return <ReactJson src={messageDetails} collapsed={1} displayDataTypes={false} />
  // return <div>{`${messageDetails ? JSON.stringify(messageDetails).substring(0, 90) : 'Empty'} ... `}</div>
}
